export default __webpack_public_path__ + "static/media/bETHIcon.771ed526.svg";